import { render, staticRenderFns } from "./GlobalDashboardBarChart.vue?vue&type=template&id=6971b372&scoped=true&"
import script from "./GlobalDashboardBarChart.vue?vue&type=script&lang=js&"
export * from "./GlobalDashboardBarChart.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDashboardBarChart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GlobalDashboardBarChart.vue?vue&type=style&index=1&id=6971b372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6971b372",
  null
  
)

export default component.exports